import { createContext, useContext, useState } from "react"

const EventContext = createContext({})
export const useEvent = () => useContext(EventContext)

export const EventContextProvider = ({ children }) => {
  const [currentEvent, setCurrentEvent] = useState("")
  const [currentRegistry, setCurrentRegistry] = useState("")

  const value = {
    currentEvent,
    currentRegistry,
    setCurrentEvent,
    setCurrentRegistry
  }

  return <EventContext.Provider value={value}>{children}</EventContext.Provider>
}
